<template>
  <div class="roma-list-activities">
    <!-- main header -->

    <div class="card-header ">
      <!-- <v-row v-if="lesson">
        <v-col md="9">
          <v-row class="row-title">
            <v-col cols="auto">
              <p v-if="lesson.subject" class="text-capitalize">
                {{ capitalizeString(lesson.subject.name) }}
              </p>
            </v-col>
            <v-col cols="auto">
              <p v-if="lesson.section" class="text-capitalize">
                {{ capitalizeString(lesson.section.nameAndCategoryName) }}
              </p>
            </v-col>
          //   <v-col class="text-center">
          //   <span>Entrega 20/20/2020 11</span>
          //  </v-col> 
          </v-row>
        </v-col>
      </v-row> -->
      <!-- content -->
      <v-row class="block-content">
        <v-col cols="2"
                    md="2" 
                    sm="2"
                    xs="2"
                    class="d-flex align-center justify-center">
          <v-progress-circular
            :rotate="-90"
            :size="140"
            :width="10"
            :value="generalAdvance"
            :color="progress(generalAdvance)"
            class="progress-circular"
          >
            <!--<v-avatar class="roma-card__avatar-card">
            <span class="progress-value">{{ generalAdvance }}%</span>
          </v-avatar>-->

            <img
              class="img-circle"
              src="@/assets/images/placeholder_lesson.png"
              alt="John"
            />
          </v-progress-circular>
        </v-col>

        <v-col v-if="lesson" 
        cols="10"
        md="10"
        sm="10"
        xs="10"
        class="block-content__content" >
          <div class="course_category">
            <span v-if="lesson.subject" class="text-capitalize">
              {{ capitalizeString(lesson.subject.name) }}
            </span>
            <span v-if="lesson.section" class="text-capitalize">
            - {{ capitalizeString(lesson.section.nameAndCategoryName) }}
            </span>
            <span v-if="lesson.code">
              - {{ lesson.code }}</span>
          </div>
          
          <h1 
          class="block-content__title light-blue--text">{{
            lesson.title
          }}</h1>
          <quillEditor
            class="lesson-detail__quill"
            :content="lesson.description"
            :options="editorOption"
            :disabled="true"
          />
        </v-col>
      <!-- botonera -->
          <v-btn
            rounded
            color="accent" 
            class="text-center text-capitalize actions__buttons"
            @click="
              redirectToFirstResourceActivity(getActivities[0].activityTOS[0])
            "
            :disabled="!getActivities.length"
          >
            <v-icon class="ml-2">roma-icon-rocket</v-icon>
            <span v-if="lesson.percentageCompletion <= 0">
              Empezar 
            </span>
            <span v-else>Continuar</span>
          </v-btn>

      </v-row>
    </div>
    <!-- activity list -->
    <template  v-if="getActivities.length">
      <v-row class="wrapper">
        <v-col 
          cols="12"
          v-for="(activity, index) in getActivities"
          :key="index"
        >
          <v-card  
          display
          class="
          
          pr-5 pt-4 pb-4 pl-6 title-card d-flex justify-space-between">
            <div class="d-flex align-center">
              <img
                v-if="activity.name == 'Aprendiendo'"
                src="../../assets/icons/reading-book.svg"
              />
              <img
                v-if="activity.name == 'Ejercitándome'"
                src="../../assets/icons/lamp.svg"
              />
              <img
                v-if="activity.name == 'Evaluando'"
                src="../../assets/icons/vote.svg"
              />
              <span 
            >
                  {{ activity.name }}
              </span>
             
            </div>
            <div v-if="activity.activityTOS" 
            :style=" getDoneActivites(activity.activityTOS) == activity.activityTOS.length ? 'color: #00A0C6;' : '' ">
              <span>
              {{getDoneActivites(activity.activityTOS)}}
              </span>
              /
              <span v-if="activity.activityTOS.length > 0">
                {{activity.activityTOS.length}}
              </span>
              
            </div>
          </v-card>
          <div cols="12" class="pr-5 pl-5 pt-2">
            <div
              color="transparent"
              v-for="(item, i) in activity.activityTOS"
              :key="i"
            >
              <v-list-item cols="12" 
              class="wrapper-row
                    d-flex 
                    flex-wrap
                    align-center 
                    justify-space-between
                    "
              @click="redirectToFirstResourceActivity(item)">
           
                <div
                  class="d-flex align-center ">
                      <v-icon
                        color="light-blue">
                        mdi-text-box-outline
                        </v-icon>
                    <span
                      class="
                      activity-title
                      ml-4
                      list-item-title text-capitalize light-blue--text"
                    >
                    {{item.title}}
                    </span>
                </div>
                <div class="d-flex 
              
                    flex-wrap
                justify-center text-capitalize ">
                  <div>
                    <span v-if="item.taskSubmitted==true && item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.state === 0 && dateAfterDate(item.taskDetails.taskDelivededDate,item.deadline.substring(0,10)) == true" style="color: #0000FF" class="activity-name">Enviada con retraso</span>
                    <span v-else-if="item.taskSubmitted==true && item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.state === 0" style="color: #0000FF" class="activity-name">Enviada</span>
                    <span v-else-if="(item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.achievement && item.taskDetails.achievement>0) || (item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.score && item.taskDetails.score>0)" style="color: #008B5C" class="activity-name">Evaluada</span>
                    <span v-else-if="(item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.achievement && item.taskDetails.score==null) || (item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.score==null)" style="color: #FF0000" class="activity-name">Sin nota</span> 
                    <span v-else-if="item.isTask == true && todayAfterDate(item.deadline.substring(0,10)) == true" style="color: #FF0000" class="activity-name">Retraso</span>   
                    <span v-else-if="item.isTask == true" style="color: #EF7F1A" class="activity-name">Pendiente</span>                   
                    <span v-else style="color: #FF0000" class=" activity-deadline"></span>
                  </div>
                  <div>
                    <span v-if="item.taskSubmitted==true && item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.state === 0" style="color: #0000FF" class="activity-deadline">{{formatDateWithHour(item.taskDetails.taskDelivededDate)}}</span>
                    <span v-else-if="(item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.achievement && item.taskDetails.achievement>0) || (item.taskDetails!==undefined && item.taskDetails!==null && item.taskDetails.score && item.taskDetails.score>0)" style="color: #008B5C" class=" activity-deadline">{{formatDateWithHour(item.taskDetails.taskCheckedDate)}}</span>
                    <span v-else-if="item.isTask == true && todayAfterDate(item.deadline.substring(0,10)) == true" style="color: #FF0000" class=" activity-deadline">{{item.deadline.substring(0,10)}}</span>
                    <span v-else-if="item.isTask == true && item.deadline.substring(0,10) != '01/01/1970'" style="color: #EF7F1A" class=" activity-deadline">{{item.deadline.substring(0,10)}}</span>
                    <span v-else style="color: #FF0000" class=" activity-deadline"></span>

                  </div>

                  <div>
                    <v-icon v-if="item.progress == 100" color="green"
                    class="activity-check"
                      >mdi-check</v-icon
                      >
                    <span v-else class=" activity-check"></span>

                  </div>
                </div>
                

                <!-- <v-list-item-icon>
                    <span class="send">
                      <v-icon v-if="item.state !== ''">
                        mdi-telegram
                      </v-icon>
                    </span>
                  </v-list-item-icon> 
                    <v-icon color="green" class="pl-3">mdi-check</v-icon>
                    {{ item.code }}
                     -->
              </v-list-item >
            </div>

            <!-- <v-row
              v-for="(item, i) in activity.activityTOS"
              :key="i"
              no-gutters
              class="align-center"
            > -->
            <!-- <template v-if="item && item.resourceTypeTO"> -->
            <!-- title -->
            <!-- <v-col>
                  <v-col class="icons-card-list"> -->
            <!-- text/video/pdf resource link -->
            <!-- <router-link
                      :to="{
                        name: 'ActivityType',
                        params: {
                          id: item.activityLessonId,
                          type: getUrlActivity(item.resourceTypeTO.type),
                        },
                      }"
                    > -->
            <!-- <v-icon color="blue">
                        {{ getIconActivity(item.resourceTypeTO.type) }}
                      </v-icon> -->
            <!-- {{ item.title }} -->
            <!-- </router-link> -->
            <!-- </v-col>
                </v-col> -->
            <!-- task status -->
            <!-- <v-col cols="auto">
                  <v-col cols="12">
                    <span class="send">
                      {{ item.status }}
                      <v-icon v-if="item.status !== ''">mdi-telegram</v-icon>
                    </span>
                  </v-col>
                </v-col> -->
            <!-- task check -->
            <!-- <v-col cols="auto">
                  <v-col class="code">
                    <v-icon color="green">mdi-check</v-icon>
                    {{ item.code }}
                  </v-col>
                </v-col> -->
            <!-- date -->
            <!-- <v-col cols="auto">
                  <v-col>
                    <span class="date">
                      20/12/2020
                    </span>
                  </v-col>
                </v-col> -->
            <!-- </template> -->
            <!-- </v-row> -->
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="justify-center">
        <v-col cols="auto">
          <h1>Aun no hay actividades</h1>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

// MIXINS
import Utility from "@/mixins/Utility";
import moment from 'moment'

export default {
  components: {
    quillEditor
  },
  mixins: [Utility],
  data() {
    return {
      course: "",
      grade: "",
      alumns: 0,
      classCode: "Código de clase",
      title: "El Cuento",
      empty: false,
      generalAdvance: 0,
      color: null,
      activities: [
        {
          aprendiendo: [
            {
              title: "Que es el cuento",
              type: "text"
            },
            {
              title: "Que es el cuento",
              type: "video"
            },
            {
              title: "Que es el cuento",
              type: "pdf"
            }
          ]
        },
        {
          Ejercitandome: [
            {
              title: "Que es el cuento",
              type: "text"
            },
            {
              title: "Que es el cuento",
              type: "video"
            },
            {
              title: "Que es el cuento",
              type: "pdf"
            }
          ]
        }
      ],
      editorOption: {
        readOnly: true,
        modules: {
          toolbar: false
        },
        placeholder: ''
      }
    };
  },
  async mounted() {
    this.setLesson({});
    this.setActivities([]);
    await this.actionGetLesson(this.$route.params.id);
    await this.getActivitiesByLessonId(this.$route.params.id);
    await this.activityWithResourceSort();
  },
  computed: {
    ...mapGetters({
      getUserData: "getUserData",
      lesson: "getLesson",
      getActivities: "getActivities",
      getActivitiesTypes: "getActivitiesTypes",
      getCurrentResources: "getCurrentResources"
    })
  },
  methods: {
    ...mapActions({
      actionGetLesson: "actionGetLesson",
      setLesson:"setOneLesson",
      setActivities:"setActivities",
      actionSetCurrentActivity: "actionSetCurrentActivity",
      actionSetCurrentResource: "actionSetCurrentResource",
      getActivitiesByLessonId: "getActivitiesByLessonId",
      actionSetCurrentResources: "actionSetCurrentResources",
      actionSetResourcePaginationIndex: "actionSetResourcePaginationIndex",
      actionResetCurrentResources: "actionResetCurrentResources"
    }),
    progress(value) {
      console.log("Valor progreso: " + value);
      if (value <= 25) {
        this.color = "secondary";
      } else if (value >= 26 && value <= 49) {
        this.color = "purple";
      } else if (value >= 50 && value <= 75) {
        this.color = "accent";
      } else if (value >= 76 && value <= 90) {
        this.color = "blueMedium";
      } else {
        this.color = "green";
      }
      return this.color;
    },

    async activityWithResourceSort() {
      const arrayResourcesWithActivity = [];
      let countingProgress = 0;
      let countingActivities = 0;
      this.getActivities.forEach(activityGroup => {
        activityGroup.activityTOS.forEach((activityTo, i) => {
          // Quitar recursos para evitar anidarlos nuevamente
          delete activityTo.resourceTypeTO;

          // datos basicos de la actividad
          const auxActivity = {
            activityLessonId: activityTo.activityLessonId,
            code: activityTo.code,
            lessonId: activityTo.lessonId,
            title: activityTo.title,
            instructive: activityTo.instructive,
            isTask: activityTo.isTask,
            taskSubmitted: activityTo.taskSubmitted,
            taskDetails: activityTo.taskDetails
          };

          countingProgress = countingProgress + activityTo.progress;
          countingActivities++;

          activityTo.resourcesTo.forEach((resourceTo, i) => {
            // seteando datos basicos de actividad dentro de cada recurso
            resourceTo.activity = auxActivity;

            // llenando array de recursos con datos de la actividad
            arrayResourcesWithActivity.push(resourceTo);
          });
        });
      });

      console.log("Sum progreso: " + countingProgress);
      console.log("Sum actividades: " + countingActivities);

      this.generalAdvance = countingProgress / countingActivities;

      console.info("RECOURCES AUX", arrayResourcesWithActivity);

      this.actionSetCurrentResources(arrayResourcesWithActivity);
    },

    async searchFirstResourceIndexForActivity(activity) {
      const index = await this.getCurrentResources.findIndex(
        resource =>
          resource.activity.activityLessonId === activity.activityLessonId
      );
      console.log(index);
      this.actionSetResourcePaginationIndex(index);
      this.redirectToResource(this.getCurrentResources[index]);
    },

    redirectToFirstResourceActivity(activity) {
      console.info("ACTIVIDAD", activity);
      this.searchFirstResourceIndexForActivity(activity);
    },

    redirectToResource(resource) {
      // Guardando recurso actual en vuex
      this.actionSetCurrentResource(resource);
      this.actionSetCurrentActivity(resource.activity);

      this.$router.push({
        name: "ActivityType",
        params: {
          id: resource.resourcesId,
          type: this.getUrlActivity(resource.resourceType.type)
        }
      });
    },
    setCurrentActivityStore(activity) {
      this.actionSetCurrentActivity(activity);
    },
    isReadable(resource) {
      let response = false;

      switch (resource.resourceType.name) {
        case "ARCHIVO":
          if (resource.fileName) {
            const nameArray = resource.fileName.split(".");
            const extension = nameArray[nameArray.length - 1];

            // 1 - legibles
            // 2 - descargables
            // 3 - link externo

            switch (extension) {
              case "pdf":
                response = 1;
                break;

              case "png":
                response = 1;
                break;

              case "jpeg":
                response = 1;
                break;

              case "jpg":
                response = 1;
                break;

              default:
                response = false;
                break;
            }
          }
          break;

        case "VIDEO ENLACE":
          response = 1;
          break;

        case "TEXTO ENRIQUECIDO":
          response = 1;
          break;

        case "ENLACE EXTERNO":
          response = 1;
          break;

        case "ENLACE EXTERNO EMBEBIDO":
          response = 1;
          break;

        default:
          response = false;
          break;
      }

      return response;
    },
    capitalizeString(string) {
      return string.toLowerCase();
    },
    optionFilter() {
      return [
        {
          label: this.$vuetify.lang.t("Actividad"),
          type: "text",
          cols: 8,
          model: { id: 0, text: this.$vuetify.lang.t("Actividad") },
          query: `activity=`,
          options: ""
        },
        {
          label: this.$vuetify.lang.t("Código"),
          type: "text",
          cols: 4,
          model: { id: 0, text: this.$vuetify.lang.t("Código") },
          query: `activity=`,
          options: ""
        }
      ];
    },
    getIconActivity(type) {
      if (type === "TEXT") {
        return "roma-icon-text";
      } else if (type === "EXTERNAL_LINK") {
        return "mdi-link";
      } else if (type === "FILE") {
        return "roma-icon-pdf";
      } else if (type === "VIDEO_LINK") {
        return "roma-icon-video";
      } else if (type === "EXTERNAL_LINK_EMBEDDED") {
        return "mdi-link";
      } else {
        return "";
      }
    },
    getDoneActivites(listActivities){
      let counter = 0;
      for (let i = 0; i < listActivities.length; i++) {
        if (listActivities[i].progress == 100) {
          counter  = counter + 1
        }
      }
    return counter
    },
    formatDateWithoutHour(date) {
            return moment(date).format("DD-MM-YYYY");
    },
    todayAfterDate(date) {

      if(date == '01/01/1970'){
        return false;
      }

      date = date + " 23:59";

      return moment() > moment(date, "DD/MM/YYYY HH:mm");
    },
    dateAfterDate(date1, date2) {

      if(date2 == '01/01/1970'){
        return false;
      }

      date2 = date2 + " 23:59";

      return moment(date1) > moment(date2, "DD/MM/YYYY HH:mm");
    },
    formatDateWithHour(date) {
            return moment(date).format("DD-MM-YYYY HH:MM");
    }
  }

};
</script>

<style lang="scss">
@import url("../../assets/styles/colors.scss");

.roma-icon-download-purple:before {
  content: url("../../assets/icons/cloud-computing-purple.svg");
}

.roma-icon-text:before {
  content: url("../../assets/icons/Texto.svg");
}

.roma-icon-video:before {
  content: url("../../assets/icons/Videos.svg");
}

.roma-icon-pdf:before {
  content: url("../../assets/icons/Pdf.svg");
}

.roma-list-activities {
  padding: 5px 0 0 5px;
  .lesson-detail__quill {
    .ql-container.ql-snow.ql-disabled {
      border: none;
    }
    // background-color: #bada55;
    * {
      font-family: "Cabin", sans-serif !important;
      font-weight: normal;
      font-size: 18px;
    }
  }
  .ql-editor {
        padding: 0 !important;
        margin: 0 !important;
    }

  .filter-container {
    left: 25%;
    width: 60%;
    top: 12%;
    border-radius: 35px;
  }

  .no-padding {
    padding: 0 !important;
  }

  .row-title {
    font-size: 1.1em;
  }

  .block-content {
    color: map-get($colors, "text");
    position: relative;
    .img-circle {
      border-radius: 100%;
      width: 120px;
    }

    h1 {
      padding: 8px 0;
      color: map-get($colors, "primary");
      font-weight: normal;
    }

    p {
      font-weight: normal;
      line-height: 1.5em;
      font-size: 1em;
    }
    
    &__title {
            font-size: 32px;
        }
    .course_category{
        color: #616161;
        font-size: 16px;
    }
  }

  h1 {
    padding: 8px 0;
    color: map-get($colors, "primary");
    font-weight: normal;
  }

  .btn-create {
    text-transform: capitalize;
    font-size: 1.5em;
    padding: 15px 40px !important;
    border-radius: 100px !important;
    height: 70px !important;

    img {
      margin-left: 15px;
    }
  }

  .actions {
    float: right;

    button {
      color: #818181 !important;
      text-transform: capitalize;
      background: transparent !important;
      border: none !important;
      box-shadow: none;
      font-weight: normal;
      font-size: 1.25em !important;
      line-height: 1.5em;
      padding: 0 6px !important;
    }

    button:hover {
      box-shadow: none !important;
      background: transparent !important;
    }

    .active {
      color: #3a8fce !important;
    }
  }

  .actions__buttons{
    position: absolute;
    top: 0;
    right: 10px;
  }

  h2 {
    padding: 15px 0 10% 10px;
    color: map-get($colors, "primary");
    font-weight: normal;
    font-size: 2em !important;
  }

  .card-content-list {
    padding: 20px 2% 10px 6%;
  }

  .card-content-list-comments {
    padding: 10px 2% 10px 6%;
  }

  .card-list-activity {
    padding: 0;
    border-radius: 15px !important;

    span:nth-child(1) {
      padding: 35px 0;
      color: map-get($colors, "text");
    }

    .date-activity {
      color: map-get($colors, "blue") !important;
      text-align: right;
    }

    .title-list-activity {
      padding: 5px 0 10% 10px;
      color: map-get($colors, "blue") !important;
      font-weight: normal;
      font-size: 1.85em !important;
    }
  }

  .transparent {
    background: transparent;
    border: none !important;
    box-shadow: none;
  }

  .icon-create-activity:before {
    content: url("../../assets/icons/create-activity-icon-white.svg");
    width: 32px;
    margin-left: 10px;
  }

  .input-comments {
    i {
      color: map-get($colors, "accent") !important;
    }
  }

  .md-10 {
    width: 90%;
  }

  .md-1 {
    width: 5%;
  }

  .btn-clear {
    padding: 0 5px;

    i {
      color: map-get($colors, "accent") !important;
    }
  }

  .btn-download-source {
    font-size: 18px;
    font-weight: normal;
    text-transform: capitalize;
    color: map-get($colors, "purple");
    line-height: 18px;
    height: 50px;
    box-shadow: 0 6px 15px #00000029;
    i {
      padding-left: 10px;
    }
  }

  .title-card {
    display: flex;
    align-items: center;
    font-size: 20px;
    text-transform: capitalize;
    color: map-get($colors, "text");

    img {
      margin: 0 10px 5px 0;
    }

    .roma-icon-title-aprendiendo:before {
      content: url("../../assets/icons/create-activity-icon.svg");
    }

    .roma-icon-title-ejercitandome:before {
      content: url("../../assets/icons/pencil.svg");
    }

    .roma-icon-title-evaluando:before {
      content: url("../../assets/icons/task.svg");
    }
  }

  .icons-card-list {
    font-size: 20px;
    font-weight: normal;
    i {
      font-size: 20px;
      margin-right: 15px;
    }
    a {
      text-decoration: none;
      color: #4a4a4a;
    }
  }

  .send {
    color: map-get($colors, "green");
    font-weight: 400;
    i {
      color: map-get($colors, "green") !important;
    }
  }

  .date {
    color: map-get($colors, "blue");
    font-weight: 400;
    font-size: 13px;
  }

  .code {
    color: map-get($colors, "text");
    font-weight: 400;
    font-size: 14px;
  }

  .roma-icon-rocket:before {
    content: url("../../assets/icons/spring-swing-rocket.svg");
  }

  .btn-rocket {
    a {
      text-decoration: none;
    }
  }
}

.list-item-title {
  font-size: 20px;
  font-weight: normal;
}

.hover-activity:hover {
  cursor: pointer;
  color: #ff7400;
}

.card-header {
  background-color: #fffdfd;
  padding: 1rem;
  border-radius: 5px;
}
.wrapper{
  margin: 10px !important;
}

.wrapper-row{
  justify-content: space-between !important;
    .activity-title{
        // max-width:100% ; 
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;

    }
    .activity-name{
        width:120px; 
        display: inline-block;

    }
    .activity-deadline{
       width:160px; 
       display: inline-block;

    }
    .activity-check{
       width:50px; 
       display: inline-block;
    }
}
.v-list-item::after {
    content: none !important;
}

@media (max-width: 599px) {
  .list-item-title {
    font-size: 16px !important;
  }
  .activity-title{
      width:150px !important; 
  }
  .actions__buttons{
      top: initial  !important;
      bottom: -25px;
      right: 0;
  }
  .block-content {
    margin: 10px;
    &__title {
        font-size: 17px  !important;
    }
    .course_category{
        font-size: 12px  !important;
    }
  }
  .content-text{
    margin-top: 30px;
  }
  .progress-circular{
    width:60px !important;
    .img-circle {
        width: 60px !important;
      }
  }
  .lesson-detail__quill {
    * {

      font-size: 10px !important;
    }
  }

}
</style>
